export const initialState = {
  type: null,
  reason: null,
  subject: '',
  isSchedule: false,
  scheduledFor: null,
};
